import React from "react";

const HeaderBackground = () => {
  return (
    <div className={`h-full top-0 left-0 -z-1 bg-theme-black shadow-inset-bottom absolute w-full`} />
  );

}

export default HeaderBackground